import React from 'react';
import { Zap } from 'lucide-react';
import AnimatedSection from '../AnimatedSection';

const SectionHeader = ({ title, subtitle, icon = <Zap className="h-5 w-5" />, badgeText = "Featured" }) => {
  return (
    <AnimatedSection>
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2 bg-avn-purple-100 px-4 py-2 rounded-full text-avn-purple-700 mb-8">
          {icon}
          <span>{badgeText}</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {title}
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          {subtitle}
        </p>
      </div>
    </AnimatedSection>
  );
};

export default SectionHeader;